import * as React from "react";
import { Formik, Form } from "formik";
import { useHistory } from "react-router-dom";

// Components
import Container from "../components/Container/Container";
import Button from "../components/Button/Button";
import InputFile from "../components/InputFile/InputFile";
import Footer from "../components/Footer/Footer";

// Misc.
import { useBaseDispatch } from "../context/Base.context";

const ContinuePage: React.FC = () => {
  const baseDispatch = useBaseDispatch();
  const history = useHistory();
  const [disabled, setDisabled] = React.useState(true);

  const fetchData = async (values: any) => {
    const { file } = values.file;
    const formData = new FormData();
    formData.append("bundleFile", file as any);

    try {
      const decryptedProgressData = await fetch(
        "/resilience-scanner/api/v1/bundle/read",
        {
          method: "POST",
          body: formData,
        }
      ).then((response) => response.json());

      const { data } = decryptedProgressData;

      baseDispatch({ type: "add", payload: data });
      history.push("/categories");
    } catch (error) {
      // eslint-disable-next-line no-alert
      alert("An Error occured trying to read your encrypted progress file.");
    }
  };

  return (
    <>
      <Container>
        <div className="w-11/12 xxl:w-full mx-auto">
          <h1 className="text-dw-blue text-2xl font-serif font-semibold">
            Continue crisis plan
          </h1>
          <p className="text-dw-grey-13 font-bold my-3">
            You can upload the file you received when you saved your crisis plan
            the last time.
          </p>
          <p className="text-dw-grey-13 font-bold">
            The file ends on "resiliencescanner". Once you uploaded the file,
            the saved version will be restored, and you can continue editing
            your crisis plan.
          </p>
          <Formik
            initialValues={{
              file: {
                file: null,
                name: "",
                size: 0,
              },
            }}
            onSubmit={fetchData}
          >
            <Form>
              <InputFile name="file" fileSet={() => setDisabled(false)} />
              <div className="sm:flex">
                <Button
                  type="button"
                  buttonType="secondary"
                  className="mb-3 sm:mb-0 sm:w-auto sm:ml-auto sm:mr-0"
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  Back
                </Button>
                <Button
                  type="submit"
                  className="sm:w-auto sm:ml-3"
                  disabled={disabled}
                >
                  Submit
                </Button>
              </div>
            </Form>
          </Formik>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default ContinuePage;
